const applicationInitialState = {
  isInstantiated: false,
  env: null,
  version: '0.0.1',
  serviceDiscovery: [],
  exception: []
};

export default applicationInitialState;
